@import (reference) '../../../../../constants/spacing.module.less';

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @space-16 @space-24;
  border-bottom: 1px solid var(--grey-200);
  flex-shrink: 0;
}

.title {
  font-weight: 600;
  color: var(--grey-900);
}

.body {
  flex: 1;
  overflow: auto;
}

.content {
  flex: 1;
  overflow: hidden auto;
  padding: @space-24;
}

.footer {
  background-color: var(--white);
  border-top: 1px solid var(--grey-300);
  flex-shrink: 0;
  padding-top: @space-24;
  padding-bottom: @space-24;
  padding-right: @space-16;
}
